export const GlobalAdvanceSearchStatus = {
  REQUEST: 'Global_Advance_Search_REQUEST',
  SUCCESS: 'Global_Advance_Search_Status_SUCCESS',
  ERROR: 'Global_Advance_Search_Status_ERROR',
  RESET: 'Global_Advance_Search_Status_RESET',
};
